<!--
Author: TangChen
Date: 2018-11-06
Desc: CRS信息，由index.js 配置引入
-->
<template>
    <div :class="'view-ben-list view bg-white ' + className">
        <comp-title :title="title">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/orginfo' }">
                    信息中心
                </el-breadcrumb-item>
                <el-breadcrumb-item>{{ title }}</el-breadcrumb-item>
            </el-breadcrumb>
        </comp-title>
        <div class="existbenef">
            <el-form
                ref="benInfo"
                :model="benInfo"
                :rules="rules"
                label-width="160px"
                class="acct-form"
                size="small"
            >
                <el-col :span="24">
                    <el-col :span="12">
                        <el-form-item label="是否存在受益人：" class="required">
                            <el-radio-group v-model="benInfo.existbenef">
                                <el-radio
                                    v-for="item in $cache.getDict('120123')"
                                    :key="item.subitem"
                                    :label="item.subitem"
                                    :value="item.subitem"
                                >
                                    {{ item.subitemname }}
                                </el-radio>
                            </el-radio-group>
                        </el-form-item>
                    </el-col>
                    <el-col v-if="benInfo.existbenef=='1'" :span="12">
                        <el-form-item label="豁免原因：" class="required" prop="exemption">
                            <el-select
                                v-model="benInfo.exemption"
                                filterable
                                placeholder="请选择豁免原因"
                            >
                                <el-option
                                    v-for="item in $cache.getDict('120124')"
                                    :key="item.subitem"
                                    :label="item.subitemname"
                                    :value="item.subitem"
                                />
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col v-if="benInfo.existbenef=='2'" :span="12">
                        <el-form-item label="其他原因：" class="required" prop="otherreason">
                            <el-input
                                v-model="benInfo.otherreason"
                                placeholder="请输入其他原因"
                                :maxlength="32"
                            />
                        </el-form-item>
                    </el-col>
                </el-col>
                <div class="addTax">
                    <el-button type="yellow" v-on:click="setExistbenef('benInfo')">
                        确认修改
                    </el-button>
                </div>
            </el-form>
        </div>
        <el-table v-if="benInfo.existbenef=='0'" :data="benLists" style="width: 100%" class="tab-list-tit">
            <el-table-column prop="custorgtype" label="受益人所属类型" align="center" :formatter="custorgFormat" />
            <el-table-column prop="beneficiarytp" label="受益人类型" align="center" :formatter="benFormat" />
            <el-table-column prop="beneficiaryname" label="受益人名称" align="center" />
            <el-table-column prop="benefcertype" label="证件类型" align="center" :formatter="certyFormat" />
            <el-table-column prop="benefcerno" label="证件号码" align="center" />
            <el-table-column prop="beneficiaryserialno" label="证件流水" align="center" />
            <el-table-column label="操作" align="center" width="320">
                <template slot-scope="scope">
                    <div class="btn-group">
                        <el-button type="yellow" size="small" v-on:click.once="$router.push({name:'beneficiaryinfo',query:{beneficiaryid:scope.row.beneficiaryid}})">
                            修改/详情
                        </el-button>
                        <el-button
                            type="red"
                            size="small"
                            v-on:click="delTaxes(scope.row)"
                        >
                            删除
                        </el-button>
                    </div>
                </template>
            </el-table-column>
        </el-table>
        <el-row>
            <div v-if="benInfo.existbenef=='0'&&this.$cache.getUser().existbenef==='0'" class="addTax">
                <el-button type="yellow" v-on:click.once="$router.push({name:'beneficiaryinfo'})">
                    <i
                        class="fa fa-plus-circle"
                    /><span>新增受益人信息</span>
                </el-button>
            </div>
        </el-row>
    </div>
</template>
<script>
import mixin from "@/assets/js/mixin";

export default {
    name: "TaxesList",
    mixins: [mixin],
    data () {
        return {
            taxestypes: [],
            benLists: [],
            birth: "",
            benInfo: {
                existbenef: "",
                exemption: "",
                otherreason: ""
            },
            checkbenInfo: {},
            rules: {
                exemption: [
                    { required: true, message: "请选择豁免原因", trigger: "change" }
                ],
                otherreason: [
                    { required: true, message: "请输入其他原因", trigger: "blur" }
                ]
            }
        };
    },
    watch: {
        "benInfo.existbenef" (val) {
            if (val === "0") {
                this.benInfo.exemption = "",
                this.benInfo.otherreason = "";
            }
            if (val === "1") {
                this.benInfo.otherreason = "";
            }
            if (val === "2") {
                this.benInfo.exemption = "";
            }
        }
    },
    created () {
        const info = this.$cache.getUser();
        this.benInfo.existbenef = info.existbenef;
        if(this.benInfo.existbenef == "1")
            this.benInfo.exemption = info.otherreason;
        if(this.benInfo.existbenef == "2")
            this.benInfo.otherreason = info.otherreason;
        this.getTaxesInfo();
        this.checkbenInfo = Object.assign({}, this.checkbenInfo, this.benInfo);
    },
    methods: {
        certyFormat (row, column, value) {
            const info = this.$cache.getUser();
            return (info.beneficiaryinvtp==0)?this.$cache.getDict("130008", value):this.$cache.getDict("130007", value);
        },
        countyFormat (row, column, value) {
            return this.$cache.getDict("120109", value) || "--";
        },
        custorgFormat (row, column, value) {
            return this.$cache.getDict("120125", value);
        },
        benFormat (row, column, value) {
            return this.$cache.getDict("120126", value);
        },
        // 删除税收居民信息
        delTaxes (row) {
            const _this = this;
            this.$confirm("您确认删除该受益人信息吗？", "受益人信息删除", {
                confirmButtonText: "删除",
                cancelButtonText: "取消",
                type: "warning"
            }).then(() => {
                _this.$util.request("anon/orgBeneficiary", { beneficiaryid: row.beneficiaryid,beneficiaryserialno: row.beneficiaryserialno }, "DELETE").then(res => {
                    if (res.data) {
                        _this.benLists = _this.benLists.filter(item => {
                            return item.beneficiaryid !== row.beneficiaryid;
                        });
                        _this.$message({
                            type: "success",
                            message: "删除成功!"
                        });
                    }
                });
            });
        },
        setExistbenef(formName) {
            const _this = this;
            if(JSON.stringify(_this.checkbenInfo) == JSON.stringify(_this.benInfo)) {
                _this.$message({
                    type: "info",
                    message: "表单数据未改变，请勿重复提交"
                });
                return;
            }
            _this.$refs[formName].validate(valid => {
                if (valid) {
                    if(_this.benInfo.existbenef === "1"){
                        _this.benInfo.otherreason = _this.benInfo.exemption;
                    }
                    _this.$util.request("anon/saveBeneficiary", {"existbenef": _this.benInfo.existbenef,"exemption": _this.benInfo.exemption,"otherreason": _this.benInfo.otherreason}, "POST").then(res => {
                        if (res.data) {
                            const info = _this.$cache.getUser();
                            _this.$store.dispatch("setInfo", info).then(() => {
                                _this.$cache.refreshUser();
                                _this.$message({
                                    type: "success",
                                    message: "修改受益人信息成功" + (_this.fn ? "" : "，3秒后回到信息中心"),
                                    onClose: function () {
                                        if (_this.fn) { _this.$emit("fn-back", true); } else {
                                            _this.$router.push({ name: "orginfo" });
                                        }
                                    }
                                });
                            });
                        } else {
                            _this.$message({
                                type: "warning",
                                message: res.msg
                            });
                        }

                    });
                }
            });
        },

        getTaxesInfo () {
            const _this = this;
            this.$util.request("anon/orgBeneficiary",{ beneficiaryserialno: "" }).then(res => {
                if (res.data) {
                    for (let item in res.data[0]) {
                        res.data[0][item] = res.data[0][item].trim();
                    }
                    this.benLists = res.data;
                }

            });
        }
    }
};
</script>
<style lang="scss">
/*用户信息 */
.view-ben-list {
    padding-bottom: 50px;
    .existbenef{
        padding: 35px 20px;
    }
    .addTax {
        text-align: center;
        padding: 35px 0;
        .el-button {
            font-size: 16px;
            padding: 7px 20px;
            span {
                vertical-align: middle;
            }
        }
        i {
            font-size: 24px;
            margin-right: 5px;
            vertical-align: middle;
        }
    }
}
</style>
